module.exports = __webpack_public_path__ + "img/悠闲.d5b39268.png";